import { render, staticRenderFns } from "./FiscalRegistration.vue?vue&type=template&id=afde38c6&scoped=true"
import script from "./FiscalRegistration.vue?vue&type=script&lang=js"
export * from "./FiscalRegistration.vue?vue&type=script&lang=js"
import style0 from "./FiscalRegistration.vue?vue&type=style&index=0&id=afde38c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afde38c6",
  null
  
)

export default component.exports